import * as App from '../../app';
import * as SDK from '../../lib/sdk';
export function updPurchaseTime() {
    var _a;
    var key = 'purchaseTime';
    var time = Date.now();
    App.storage.upd((_a = {}, _a[key] = time, _a));
    SDK.Data.save(key, time);
}
